import { useMemo, useState } from "react";
import BaseDialog from "./BaseDialog";
import SignalTypes, { getSignalTypeByName } from "../models/SignalTypes";
import { noItx } from "../translationItx/itx";

function getAllSignalTypeNames(): string[] {
  const names: string[] = [];
  const keys = Object.getOwnPropertyNames(SignalTypes);
  for (const key of keys) {
    const value = (SignalTypes as any)[key];
    if (value && typeof value === "object" && value.name && typeof value.name === "string") {
      names.push(value.name);
    }
  }
  // add automatically defined to resetSignals to former one

  return ["automatisch_def", ...names.sort()];
}

export default function SelectSignalTypeDialog(props: {
  title: string;
  currentTypeName?: string;
  // Optional side-effect hook. Do NOT call dialogManager.closeDialog() from here!
  // BaseDialog already closes the dialog and will invoke this hook via dialogManager.onClose.
  onClose?: () => void;
  onSelectTypeName: (typeName: string) => void;
}) {
  const { title, currentTypeName, onClose, onSelectTypeName } = props;
  const [typePickerFilter, setTypePickerFilter] = useState("");
  const allSignalTypeNames = useMemo(() => getAllSignalTypeNames(), []);

  return (
    <BaseDialog
      title={title}
      abortCaption={noItx("Cancel")}
      noOkButton={true}
      isModal={true}
      className="dialogFitContent"
      onAbort={() => {
        onClose?.();
        return true;
      }}
      onClose={() => {
        onClose?.();
        return true;
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "8px", minWidth: "300px", maxWidth: "520px" }}>
        <div style={{ color: "#666", fontSize: "12px" }}>
          {noItx("Current:")} {currentTypeName || "Unknown"}
        </div>

        <input
          type="text"
          placeholder={noItx("Filter types...")}
          value={typePickerFilter}
          onChange={(e) => setTypePickerFilter(e.target.value)}
          style={{
            padding: "8px",
            border: "1px solid #ccc",
            borderRadius: "4px",
          }}
          autoFocus
        />

        <div style={{ overflow: "auto", maxHeight: "350px", border: "1px solid #eee", borderRadius: "6px" }}>
          {allSignalTypeNames
            .filter((name) => name.toLowerCase().includes(typePickerFilter.toLowerCase()))
            .map((typeName) => (
              <div
                key={typeName}
                style={{
                  padding: "8px 12px",
                  cursor: "pointer",
                  backgroundColor: currentTypeName === typeName ? "#e3f2fd" : "transparent",
                  borderBottom: "1px solid #eee",
                }}
                onClick={() => {
                  const newType = getSignalTypeByName(typeName);
                  if (typeName === "automatisch_def") {
                    onSelectTypeName("automatisch_def");
                  } else if (newType) {
                    onSelectTypeName(newType.name);
                  }
                  // BaseDialog handles closing (OK/Abort/X).
                  state.dialogManager.closeDialog(true);
                }}
                onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#f5f5f5")}
                onMouseLeave={(e) =>
                  (e.currentTarget.style.backgroundColor = currentTypeName === typeName ? "#e3f2fd" : "transparent")
                }
              >
                {typeName}
              </div>
            ))}
        </div>
      </div>
    </BaseDialog>
  );
}
